document.addEventListener('DOMContentLoaded', () => {

  // ✅ Correct selector - it's a div with ID, not a custom element
  const cartNotif = document.querySelector('#cart-notification');
  if (!cartNotif) return;

  function injectCheckbox() {
    if (document.querySelector('#cart-agree-wrap')) return;

    const linksDiv = cartNotif.querySelector('.cart-notification__links');
    if (!linksDiv) return;

    const viewCart = document.querySelector('a#cart-notification-button');
    const checkout = document.querySelector('#cart-notification-form button[name="checkout"]');
    const buttons  = [viewCart, checkout].filter(Boolean);

    // Lock buttons
    buttons.forEach(btn => {
      btn.style.opacity       = '0.4';
      btn.style.pointerEvents = 'none';
    });

    linksDiv.insertAdjacentHTML('beforebegin', `
      <div id="cart-agree-wrap" style="
        padding: 12px 16px;
        border-top: 1px solid rgba(0,0,0,0.1);
        font-size: 12px;
        color: #333;
        transition: opacity 0.3s ease;
      ">
        <label style="display:flex; align-items:flex-start; gap:8px; cursor:pointer;">
          <input type="checkbox" id="cart-agree-checkbox"
                 style="margin-top:3px; cursor:pointer;" />
          <span>
            By submitting a message, you agree to our
            <a href="/policies/terms-of-service" target="_blank"
               style="color: blue; text-decoration:underline;">Terms of Service</a>
            and
            <a href="/policies/privacy-policy" target="_blank"
               style="color: blue; text-decoration:underline;">Privacy Policy</a>.
          </span>
        </label>
        <p id="cart-agree-error" style="
          display:none; color:#c00;
          margin:4px 0 0 24px; font-size:11px;">
          Please agree before continuing.
        </p>
      </div>
    `);

    const checkbox = document.querySelector('#cart-agree-checkbox');
    const error    = document.querySelector('#cart-agree-error');
    const wrap     = document.querySelector('#cart-agree-wrap');

    // ✅ Tick → disappear → unlock
    checkbox.addEventListener('change', () => {
      if (checkbox.checked) {
        wrap.style.opacity  = '0';
        wrap.style.height   = '0';
        wrap.style.padding  = '0';
        wrap.style.overflow = 'hidden';
        setTimeout(() => wrap.remove(), 300);

        buttons.forEach(btn => {
          btn.style.opacity       = '1';
          btn.style.pointerEvents = 'auto';
        });
      }
    });

    // ✅ Block button clicks until agreed
    buttons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        if (!checkbox.checked) {
          e.preventDefault();
          e.stopImmediatePropagation();
          error.style.display = 'block';
        }
      }, true);
    });
  }

  function removeCheckbox() {
    const wrap = document.querySelector('#cart-agree-wrap');
    if (wrap) wrap.remove();

    const viewCart = document.querySelector('a#cart-notification-button');
    const checkout = document.querySelector('#cart-notification-form button[name="checkout"]');
    [viewCart, checkout].filter(Boolean).forEach(btn => {
      btn.style.opacity       = '';
      btn.style.pointerEvents = '';
    });
  }

  // ✅ Watch for 'active' class on the div
  const observer = new MutationObserver(() => {
    if (cartNotif.classList.contains('active')) {
      setTimeout(injectCheckbox, 200);
    } else {
      removeCheckbox();
    }
  });

  observer.observe(cartNotif, {
    attributes: true,
    attributeFilter: ['class']
  });

});
